import WebApiService from "@/services/webapi.service.js";
import LoginData from "@/models/Utente/loginData.model.js";
import IndirizziSpedizione from "@/models/Utente/indirizziSpedizione.model";

const state = {
    utente: null,
    lingua: null
}

const getters = {

    getUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            let u = localStorage.getItem("utente-AgentiCressi");
            if(u != null){
                utente = JSON.parse(new Buffer.from(u, 'base64').toString('utf-8'));
            }else{
                return null;
            }
        }
        return utente;
    },
    getNomeUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente-AgentiCressi") ?? "", 'base64').toString('utf-8'));
        }
        if(utente.DatiUtente)
            return utente.DatiUtente.Nome;

        return "";
    },
    getIndirSped: (state)=> {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente-AgentiCressi") ?? " ", 'base64').toString('utf-8'));
        }
        return utente.IndirizziSpedizione;
    },
    getIndirFattu: (state)=> {
        let utente = state.utente;
        if(!utente){
            let u = localStorage.getItem("utente-AgentiCressi");
            if(u != null){
                utente = JSON.parse(new Buffer.from( u, 'base64').toString('utf-8'));
                return utente?.IndirizziFatturazione ?? "-";
            }else{
                return "-";
            }
        }
    },
    isLoggedIn:(state) =>{
        let utente = localStorage.getItem("utente-AgentiCressi");
        if(utente != null || state.utente != null){
            return true;
        }
        return false;
    },
    getLinguaUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            let u = localStorage.getItem("utente-AgentiCressi");
            if(u != null){
                let v = new Buffer.from( u, 'base64').toString('utf-8');
                utente = JSON.parse(v);
            }else{
                return "IT"
            }
        }
        if(utente){
            return utente.Lingua;
        }else{
            return "-";
        }
    },
    getLinguaNoLogin: (state) =>{
        let lingua = state.lingua;
        if(lingua){
            let lang = localStorage.getItem("lingua");
            if(lang != null){
                lingua = JSON.parse(new Buffer.from(lang ?? " ", 'base64').toString('utf-8'));
            }else{
                return "IT";
            }
        }
        if(lingua){
            return lingua;
        }else{
            return "IT";
        }
    },
    getAuthToken: (state) => {
        let utente = state.utente;
        if(!utente){
            let u = localStorage.getItem("utente-AgentiCressi");
            if(u != null){
                utente = JSON.parse(new Buffer.from(u, 'base64').toString('utf-8'));
            }else{
                return null;
            }
        }
        return utente.Token;
    }
}

const mutations = {
    setUtente: (state, utente) => {
        state.utente = utente;
        localStorage.setItem("utente-AgentiCressi", Buffer.from(JSON.stringify(utente)).toString("base64"));
    },
    setLangUtente: (state, data) =>{
        state.utente = data;
        localStorage.setItem("utente-AgentiCressi", Buffer.from(JSON.stringify(state.utente)).toString("base64"));
    },
    setLangNoLogin: (state,data) =>{
        state.lingua = data.CodiceLingua;
        localStorage.setItem("lingua", Buffer.from(JSON.stringify(state.lingua)).toString("base64"));
    },
    setDettagliLoginUtente: (state, dettagliUtente) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("loginutente"), 'base64').toString('utf-8'));
        }
        utente.DatiUtente = dettagliUtente;
        state.utente = utente;
        localStorage.setItem("loginutente", Buffer.from(JSON.stringify(utente)).toString("base64"));
    },
    setIndirizziSpedizione: (state, indirizzi) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente-Wikini"), 'base64').toString('utf-8'));
        }
        utente.IndirizziSpedizione = indirizzi;
        state.utente = utente;
        localStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(utente)).toString("base64"));
    },
    setIndirizziFatturazione: (state, indirizzi) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(localStorage.getItem("utente-Wikini"), 'base64').toString('utf-8'));
        }
        utente.IndirizziFatturazione = indirizzi;
        state.utente = utente;
        localStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(utente)).toString("base64"));
    },
    resetUser: (state) =>{
        state.utente = null;
        localStorage.clear();
        
    }
}

const actions = {

    login: ({commit}, user) => {
        let loginData = new LoginData(user.username, user.password);
        return WebApiService.login('account/login', loginData).then(
        (data) => {
                if(data.status != 200){
                    return [false, data.Message];
                }
                else{
                    let utente = {
                        Codage: data.CodAge,
                        Cognome: data.Cognome,
                        Nome: data.Nome,
                        Token: data.Token,
                        Lingua : data.Lingua,
                    }
                    commit("setUtente", utente);
                    return [true, ""];
                }
            },
            error => {
                return [false, error];
            }
        )
        .catch(
            error => {return [false, error];}
        );
    },
    SetIndirSpedAPi: ({commit}, data) => {
        return WebApiService.get("Utente/DatiSpedizione", data.Token).then(
            (data) =>{
                if(data) {
                    let Indir = data.Data.map(o => {
                        return Object.assign(new IndirizziSpedizione(), o)
                    });
                    commit("setIndirizziSpedizione",Indir);
                }
            }
        ).catch(
            error => {return [false, error];}
        );
    },
    SetIndirFattuAPi: ({commit}, data) => {
        return WebApiService.get("Utente/DatiFatturazione", data.Token).then(
            (data) =>{
                if(data) {
                    let Indir = data.Data.map(o => {
                        return Object.assign(new IndirizziSpedizione(), o)
                    });
                    commit("setIndirizziFatturazione",Indir);
                }
            }
        ).catch(
            error => {return [false, error];}
        );
    },
    CheckLogin:({commit},data) =>{
        return WebApiService.get("Account/CheckLogin",data.Token).then(
            (data) =>{
                if(data) {
                    if(data.StatusCode == 401){
                        commit("resetUser");
                        return false;
                    }
                    return true;
                }else{
                    commit("resetUser");
                    return false;
                }
            }
        );
    },
    resetUtente: ({commit}) =>{
        return commit("resetUser");
    },
    SetLangUtente: ({commit},data) =>{
        return commit("setLangUtente",data);
    },
    SetLangNoLogin: ({commit},data) =>{
        return commit("setLangNoLogin", data);
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}